<template>
  <div class="chatWrapper" >
    <el-popover
        v-model="showPopover"
        :visible-arrow="false"
        popper-class="homeOpinionPopover"
        placement="left"
        width="400"
        trigger="click">
      <div class="chatContent">
        <div class="title">
          <span>用户满意度</span>
          <span><i class="el-icon-close" @click="clear" style="cursor:pointer;"></i></span>
        </div>
        <div class="formWrapper">
          <el-radio-group v-model="userFeedbackSatisfaction" text-color="#333">
            <el-radio label="非常满意">非常满意</el-radio>
            <el-radio label="满意">满意</el-radio>
            <el-radio label="一般">一般</el-radio>
            <el-radio label="不满意">不满意</el-radio>
          </el-radio-group>
          <el-select v-model="system" placeholder="请选择系统" size="small" style="width: 100%;margin: 12px 0">
            <el-option
                v-for="(item, index) in options"
                :key="item.id + `_${index}`"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <el-input v-model="userSuggestion" type="textarea" placeholder="请输入您的意见"  size="small"  style="width: 100%;"></el-input>
          <div style="display: flex;justify-content: flex-end">
            <el-button type="primary" size="small" style="margin-top: 12px" @click="confirm" :loading="loading">提交</el-button>
          </div>
        </div>
      </div>
      <div slot="reference" class="opinion"></div>
    </el-popover>

  </div>
</template>

<script>
import {getSectorList, getSectorPlateForm, saveUserFeedBack} from '@/api/viewIndex';

export default {
  name: 'Chat',
  data() {
    return {
      showPopover: false,
      userFeedbackSatisfaction: '非常满意',
      system: '',
      options: [],
      userSuggestion: '',
      loading: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const res = await getSectorPlateForm({});
      console.log(res);
      const list = res.data.result || [];
      this.options = res.data.result
      console.log(list, this.options, '=====================');
    },
    show() {
      this.showPopover = !this.showPopover;
    },
    confirm() {
      if (!this.userFeedbackSatisfaction) {
        this.$message.error('请选择系统');
        return
      }
      this.loading = true
      const sys = this.options.find(item => item.id === this.system);
      const data = {
        clientName: sys.name,
        userFeedbackSatisfaction: this.userFeedbackSatisfaction,
        userSuggestion: this.userSuggestion
      }
      console.log(data,sys,'data');
      saveUserFeedBack(data).then(res => {
        this.$message.success('提交成功');
        this.clear()
      }).catch(err => {

      }).finally(() => {
        this.loading = false
      })

    },
    clear() {
      this.userFeedbackSatisfaction = '非常满意';
      this.system = '';
      this.userSuggestion = '';
      this.showPopover = false;

    }
  },
};
</script>

<style scoped lang="scss">
.chatWrapper {
  position: fixed;
  right: 1rem;
  bottom: 6rem;
  width: auto;
  height: 81px;
  background: #fff;
  border-radius: 6px;
  padding: 40px 10px 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);

  .opinion {
    cursor: pointer;
    width: 28px;
    height: 28px;
    background-image: url("~./ic_02.png");
    background-size: cover;
    position: relative;

    &:hover {
      background-image: url("~./ic_01.png");
    }

    &::before {
      content: '';
      display: block;
      width: 28px;
      height: 1px;
      background: #ccc;
      position: absolute;
      top: -5px;
    }
  }


}

::v-deep .el-input--small .el-input__inner {
  background: #F6F6F6;
}
::v-deep .el-textarea .el-textarea__inner {
  height: 120px;
  background: #F6F6F6;
}

</style>
<style>
.el-popover.homeOpinionPopover {
  padding: 0;
  background: transparent;
  border: none;

  .chatContent {
    .title {
      padding: 10px 12px;
      border-radius: 6px 6px 0 0;
      background: #333333;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
    }

    .formWrapper {
      height: 260px;
      width: 100%;
      padding: 12px;
      background: #ffffff;
      border-radius: 0 0 6px 6px;
    }
  }
}
</style>
